import { render } from "./PlanRedressement.vue?vue&type=template&id=8540bb22"
import script from "./PlanRedressement.vue?vue&type=script&lang=js"
export * from "./PlanRedressement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__